import { usePriceFetcher } from '@trustpad/launchpad';

import React from 'react';
import { Popup } from '~common/components/Popup';
import { Layout } from '~common/Layout';
import { PageLayout } from '~common/PageLayout';
import { levelStakingPools } from '~config/levelPoolsConfig';
import { TPAD } from '~config/tokens';
import { useStakingStatsBatch } from '~features/tiers/components/StakingStats/useStakingStatsBatch';
import { TiersPage } from '~features/tiers/TiersPage';
import { fNum } from '~utils';

export default function Staking() {
  return (
    <Layout navbarVisibility={{ levels: false }}>
      <PageLayout
        title="Staking dashboard"
        links={[
          {
            name: 'FAQ',
            href: 'https://docs.trustpad.io/trustpad/faq-general',
          },
          {
            name: 'Diamond Hands',
            href: '/diamond-hands',
          },
          {
            name: 'TPADv2 Claiming',
            href: '/tpadv2',
          },
        ]}
        titleExtra={<GlobalStats />}>
        <TiersPage />
      </PageLayout>
    </Layout>
  );
}

function GlobalStats() {
  const tokenPrice = usePriceFetcher({
    priceRefresher: TPAD.priceRefresher,
  });
  const stats = useStakingStatsBatch(levelStakingPools, tokenPrice);
  const totalTokens = Object.values(stats).reduce(
    (acc, cur) => acc + cur.lockedTokens,
    0,
  );

  return (
    <div className="flex items-center gap-4">
      <div>
        <span className="text-xl secondary-text">TVL</span>
        <Popup btnClassName="-mt-[0.10em] text-white ml-1" header="TVL">
          <p>
            Total value locked (TVL) indicates the amount in USD and TPAD that
            is locked in all of the IDO staking pools combined.
          </p>
        </Popup>
      </div>
      <div className="float-right inline-block py-2 px-4 text-center bg-dark3 bg-opacity-50 rounded-lg shadow-2xl highlight-shadow">
        <span className="text-lg md:text-2xl brand-text">
          ${fNum(totalTokens * tokenPrice, 0)}
        </span>
      </div>
      <div className="float-right inline-block bg-dark3 bg-opacity-50 py-2 px-4 text-center rounded-lg shadow-2xl highlight-shadow">
        <span className="text-lg md:text-2xl brand-text">
          {fNum(totalTokens, 0)} TPAD
        </span>
      </div>
    </div>
  );
}
